import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { IdleMonitorService } from '@app/modules/shared/service/idle-monitor.service';

/**
 * Http Interceptor that will start/restart the Idle Monitor every time an request is made.
 */
@Injectable()
export class IdleMonitorInterceptor implements HttpInterceptor {
  constructor(private idleMonitor: IdleMonitorService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    if (req.url.includes( '/purchase/dashboard' ) === false) {
      this.idleMonitor.startMonitoring();
    }

    return next.handle(req);
  }

}
